export default __webpack_public_path__ + "static/media/promotion-bottom-2.3ade8860.jpg";